import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { Link } from 'react-router-dom';
import { Form, FormItem } from '@/components';
import { Button, CheckboxGroup, Select, Tag } from '@/ui';

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledMainTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 2rem;
  padding-bottom: 0;
  background-color: ${COLORS.GRAY_LIGHT};
  border-bottom: 1px solid ${COLORS.GREY};
`;

export const StyledPageTitle = styled.div`
  ${pickThemeFontStyles('24', '30', 'SEMI_BOLD')};
  color: ${COLORS.BLACK};
  text-align: left;
`;

export const StyledButtonsWrap = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
`;

export const StyledFiltersListWrapper = styled.div`
  display: flex;
  padding: 2rem 0;
`;

export const StyledFiltersList = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  width: 100%;

  li {
    ${pickThemeFontStyles('14', '22', 'NORMAL')};
    width: 100%;
  }
`;

export const StyledFilterButton = styled.button`
  ${pickThemeFontStyles('14', '22', 'NORMAL')};
  background: transparent;
  border: none;
  padding: 0.25rem 0;
  cursor: pointer;
  text-align: left;
  width: 100%;

  :hover {
    text-decoration: underline;
  }
`;

export const StyledTabTitleWrapper = styled.div`
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${COLORS.GREY};
`;

export const StyledCheckboxGroup = styled(CheckboxGroup)`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const StyledButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
`;

export const StyledContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 1rem;
  padding: 2rem;
`;

export const StyledSection = styled.div`
  width: 100%;
  max-width: 42rem;
  display: flex;
  flex-direction: column;
  align-items: start;
  padding: 1rem;
  border: 1px solid ${COLORS.GREY};
  border-radius: 0.5rem;
  background-color: ${COLORS.GRAY_LIGHT};
`;

export const StyledSectionWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const StyledLink = styled(Link)`
  ${pickThemeFontStyles('14', '18')};
  color: ${COLORS.NORMAL_GRAY};
  text-decoration: underline;
`;

export const StyledTitleAndLinkWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 0.375rem;
`;

export const StyledFormItem = styled(FormItem)`
  width: 100%;
`;

export const StyledFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 1.5rem;
  width: 100%;
  max-width: 38rem;
`;

export const StyledForm = styled(Form)`
  width: 100%;
`;

export const StyledTableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  height: 100%;
  width: 100%;

  .ant-table-thead > tr > th .ant-input,
  .ant-table-thead > tr > th .ant-select,
  .ant-table-thead > tr > th .ant-select-selector,
  .ant-table-thead > tr > th .ant-picker-input input {
    font-size: 0.75rem;
  }
`;

export const StyledTag = styled(Tag)`
  ${pickThemeFontStyles('14', '16', 'SEMI_BOLD')};
  text-align: start;
  width: fit-content;
  border: 1px solid ${COLORS.DARK_GRAY};
  background: ${COLORS.WHITE};
  padding: 0.25rem 0.75rem;
  border-radius: 3rem;
  height: auto;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const StyledTagWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

export const StyledOption = styled.span`
  background: ${COLORS.GREY};
  padding: 0.1rem;
  border-radius: 0.2rem;
`;

export const StyledCategoriesWrapper = styled.div`
  width: 40rem;
  padding: 4rem 3rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
`;

export const StyledPopularCategoriesTitle = styled.span`
  ${pickThemeFontStyles('14', '16', 'NORMAL')};
  margin: 0;
`;

export const StyledPopularCategoriesSubTitle = styled.span`
  ${pickThemeFontStyles('14', '16', 'NORMAL')};
  color: ${COLORS.GRAY_PRIMARY};
  margin: 0;
`;

export const StyledRow = styled.div`
  display: flex;
  gap: 1rem;
`;

export const StyledSelect = styled(Select)`
  &&& {
    min-height: 40px;

    .ant-select-selection-placeholder {
      color: ${COLORS.BLACK};
    }

    .ant-select-selector {
      overflow: hidden;
      padding-top: 0.15rem;
    }

    .ant-select-selection-overflow {
      flex-wrap: nowrap !important;
      overflow: hidden;
      white-space: nowrap;

      & .ant-select-selection-overflow-item span {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 8vw;
      }

      & .ant-select-selection-overflow-item-rest div {
        border: none;
        color: ${COLORS.GRAY_PRIMARY};
      }

      & .ant-select-selection-overflow-item-suffix {
        padding-left: 0.25rem;
      }
    }

    .ant-select-clear {
      inset-inline-end: 0.25rem;
      top: 50%;
      width: fit-content;
      height: fit-content;
    }
  }
`;

export const StyledRestorationCheckboxWrap = styled.div`
  width: 100%;
  padding: 0.75rem 1rem;
  border-radius: 0.375rem;
  background-color: ${COLORS.GRAY_LIGHT};
  border: 1px solid ${COLORS.GREY};
  border-left: 3px solid ${COLORS.YELLOW_PRIMARY};

  .ant-form-item {
    margin-bottom: 0;
  }
`;

export const StyledCategoryFlagCheckboxLabel = styled.span`
  ${pickThemeFontStyles('14', '20', 'SEMI_BOLD')};
  color: ${COLORS.BLACK};
`;

export const StyledLinkBlock = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  ${pickThemeFontStyles('14', '18', 'NORMAL')};
  padding: 0.25rem;
  text-align: center;
`;

export const StyledFeedLink = styled(Link)`
  display: flex;
  gap: 0.5rem;
  text-decoration: underline;
  color: ${COLORS.BLUE_PRIMARY};
  ${pickThemeFontStyles('14', '22', 'NORMAL')};

  svg {
    path {
      stroke: ${COLORS.BLUE_PRIMARY};
    }
  }
`;

export const StyledActionButton = styled(Button)<{ $color: string }>`
  &&& {
    background: ${({ $color }) => $color};
    padding: 0.25rem;
    border: none;
    width: 2.125rem;
    height: 2.125rem;

    :hover {
      background: ${({ $color }) => $color};
    }
  }

  svg {
    path {
      fill: ${COLORS.WHITE};
    }
  }
`;
